module.exports = __webpack_public_path__ + "media/images/steps_active_right_arrow-bdee622a8f9427fd2ac34fcb73327a89.png";